export default "__VITE_ASSET__ff2c9bfd__"